var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "professional-list" },
    [
      _vm.preloader
        ? _c(
            "div",
            { staticClass: "loader" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("p", [_vm._v("Procurando profissionais...")])
            ],
            1
          )
        : !_vm.avaliableProfessionals.length || _vm.sugestionSearch
          ? _c("Empty")
          : _vm._e(),
      _vm._v(" "),
      _vm.avaliableProfessionals.length
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.avaliableProfessionals, function(professional, index) {
              return _c("Card", {
                key: professional.id,
                attrs: {
                  index: index,
                  professional: professional,
                  shouldApplyFocus: Boolean(_vm.professionalId),
                  isSelected: professional.id === _vm.professionalId
                }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canLoadMore ? _c("LoadMore") : _vm._e(),
      _vm._v(" "),
      !_vm.canLoadMore && _vm.sugestionProfessional
        ? _c(
            "Sugestion",
            { attrs: { professional: _vm.sugestionProfessional } },
            [
              _c(
                "template",
                { slot: "card" },
                [
                  _c("Card", {
                    key: _vm.sugestionProfessional.id,
                    attrs: {
                      index: null,
                      professional: _vm.sugestionProfessional,
                      shouldApplyFocus: Boolean(_vm.professionalId),
                      isSelected:
                        _vm.sugestionProfessional.id === _vm.professionalId,
                      sugestion: true
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lowProfessionalCount() && !_vm.sugestionSearch
        ? _c("AlmostEmpty")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef9430d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef9430d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Index.vue
// module id = null
// module chunks = 